var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHands1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 122,
    viewBox: "0 0 395 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M377.978 43.69C378.336 38.0202 372.833 34.6303 366.098 30.56C363.598 29.0322 362.353 17.4301 359.422 17.6808C356.79 17.8717 357.592 24.7112 357.975 32.3863C358.441 41.9353 358.932 44.8955 358.441 48.8584C357.819 53.7881 354.721 70.9405 329.992 79.654C298.493 90.7428 267.065 70.4869 248.642 66.8941",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M388.817 12.4526C394.644 15.2577 394.177 32.3146 393.136 43.4035C390.624 70.4034 382.01 84.2256 374.844 92.7123C343.321 130.025 293.577 126.038 259.649 107.824",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M365.38 29.5693C367.857 21.7391 367.247 9.2776 369.472 2.18744C369.562 1.88948 369.731 1.6215 369.962 1.41211C370.193 1.20271 370.476 1.05975 370.782 0.998483C371.088 0.937214 371.405 0.959935 371.698 1.06422C371.992 1.16851 372.252 1.35045 372.451 1.59062C373.623 3.30064 374.261 5.31975 374.281 7.39166C374.64 13.1099 374.508 18.8483 373.886 24.5441C375.19 20.0919 375.083 15.4964 376.47 4.84923C376.793 2.46197 379.282 3.41688 380.059 5.27894C381.77 9.33728 381.459 19.137 380.945 24.5799C382.44 18.6118 381.435 8.01235 383.78 6.97389C387.824 5.18345 388.565 19.9248 387.369 26.3823",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.537 23.9111C133.111 46.9721 114.15 60.3646 92.3044 64.8765C75.5557 68.3142 48.9971 63.3248 38.4693 51.5198C33.7438 46.1843 26.1351 32.4217 22.7136 34.9164C18.634 37.8647 25.3933 48.0463 28.9465 52.6537",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 55.4587C2.62702 68.8273 29.1019 85.2994 37.3447 88.8803C90.4262 111.965 150.853 91.7211 181.396 37.2319",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3562 40.5502C7.30537 39.5834 6.83876 43.7253 7.4609 46.2797C9.11197 52.9879 14.4002 58.777 18.2287 62.9189",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1126 54.5634C27.7749 51.3048 25.7052 50.1708 20.3456 42.9971C17.4864 39.1297 13.7658 33.6032 11.5645 35.7637C7.10216 40.1085 17.0198 52.3552 23.0134 58.3352",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31958 46.208C4.3744 46.4706 2.80709 47.7 3.10619 50.4931C3.53298 55.3551 5.50281 59.9546 8.72938 63.6231",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands1);
export default __webpack_public_path__ + "static/media/hands1.22dd090d781886621960872033452754.svg";
export { ForwardRef as ReactComponent };